import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { lastValueFrom, Observable, pluck } from "rxjs";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { UserManagementService } from "../../services/user-management.service";
@UntilDestroy()
@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  roles!: UserRole[];
  emails: string[] = [];
  constructor(
    private _loginService: UserManagementService,
    private router: Router
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise<boolean>(async resolve => {
      try {
        this.roles = route.data["roles"] as UserRole[];
        this.emails = route.data["emails"] || [];
        let userObject;
        let userEmail = "";
        const userJson = localStorage.getItem("user");
        if (userJson) {
          userObject = JSON.parse(userJson);
          userEmail = userObject.idTokenClaims.preferred_username;
        }
        if (localStorage.hasOwnProperty("user")) {
          const user = await lastValueFrom(
            this._loginService
              .validateLogin()
              .pipe(untilDestroyed(this), pluck("data"))
          );
          const res = user.userRole.split(" ").join("");
          if (res)
            if (
              this.roles.includes(UserRole[res as keyof typeof UserRole]) ||
              (route.data["allowBCUser"] === true && user.isBCUser === true) ||
              this.emails.includes(userEmail)
            )
              resolve(true);
            else {
              this.router.navigate(["/", "authorization-error"]);
              resolve(false);
            }
          else {
            this.router.navigate(["/", "authorization-error"]);
            resolve(false);
          }
        } else {
          this.router.navigate(["/", "authorization-error"]);
          resolve(false);
        }
      } catch {
        this.router.navigate(["/", "authorization-error"]);
        resolve(false);
      }
    });
  }
}
